import { AbstractText } from './abstract-text.model';
import { Evaluation } from '../evaluation/evaluation.model';
import { AbstractSubmission } from './abstract-submission.model';

export class Abstract {
  constructor(
    id?: number,
    lastModifiedBy?: string,
    lastModifiedDate?: Date,
    abstractText?: AbstractText,
    administeringIC?: string,
    application?: number,
    createdDate?: Date,
    fy?: number,
    hasAdjudicationFlag?: boolean,
    hasCoderQuestionFlag?: boolean,
    piProjectLeader?: string,
    projectTitle?: string,
    projectNumber?: number,
    protocolId?: number,
    evaluationIds?: number[],
    submissions?: AbstractSubmission[],
    groupIndex?: number,
    groupCount?: number,
    abstractStatusId?: number,
    hasMlCoding?: boolean,
    returnedFromGetNextAbstract?: boolean
  ) {
    this.id = id;
    this.lastModifiedBy = lastModifiedBy;
    this.lastModifiedDate = lastModifiedDate;
    this.abstractText = abstractText;
    this.administeringIC = administeringIC;
    this.application = application;
    this.createdDate = createdDate;
    this.fy = fy;
    this.hasAdjudicationFlag = hasAdjudicationFlag;
    this.hasCoderQuestionFlag = hasCoderQuestionFlag;
    this.piProjectLeader = piProjectLeader;
    this.projectTitle = projectTitle;
    this.projectNumber = projectNumber;
    this.protocolId = protocolId;
    this.evaluationIds = evaluationIds;
    this.submissions = submissions;
    this.groupIndex = groupIndex;
    this.groupCount = groupCount;
    this.abstractStatusId = abstractStatusId;
    this.hasMlCoding = hasMlCoding;
    this.returnedFromGetNextAbstract = returnedFromGetNextAbstract;
  }

  public id: number;
  public lastModifiedBy: string;
  public lastModifiedDate: Date;
  public abstractText: AbstractText;
  public administeringIC: string;
  public application: number;
  public createdDate: Date;
  public fy: number;
  public hasAdjudicationFlag: boolean;
  public hasCoderQuestionFlag: boolean;
  public piProjectLeader: string;
  public projectTitle: string;
  public projectNumber: number;
  public protocolId: number;
  public evaluationIds: number[];
  public submissions: AbstractSubmission[];
  public groupIndex: number;
  public groupCount: number;
  public abstractStatusId: number;
  public hasMlCoding: boolean;
  public returnedFromGetNextAbstract: boolean;
}
